import React from "react";
import { LegalDocumentModal } from "@/shared/legal/LegalDocumentModal";
import TermsOfServiceBody from "./TermsOfServiceBody";
import { TOS_DOCUMENT_META } from "./termsOfServiceContent";

const TOS_MODAL_META = {
	title: TOS_DOCUMENT_META.title,
	version: TOS_DOCUMENT_META.displayVersion,
	companyName: TOS_DOCUMENT_META.companyName,
	companyLine: TOS_DOCUMENT_META.companyLine,
	effectiveDate: TOS_DOCUMENT_META.effectiveDate,
	lastUpdated: TOS_DOCUMENT_META.lastUpdated,
};

interface TermsOfServiceModalProps {
	open: boolean;
	onClose: () => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({ open, onClose }) => (
	<LegalDocumentModal open={open} onClose={onClose} meta={TOS_MODAL_META}>
		<TermsOfServiceBody embedded />
	</LegalDocumentModal>
);

export default TermsOfServiceModal;
